import React from 'react';
import PropTypes from 'prop-types';
import KpiSummary from '../../../commons/KpiSummary';

const PartnerLicensePackageUsageSummary = (props) => (
  <KpiSummary
    title="License Package Usage"
    isLoading={props.isLoading}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    standardDeviationValue={props.standardDeviationValue}
    formatter={props.formatter}
  />
);

PartnerLicensePackageUsageSummary.propTypes = {
  isLoading: PropTypes.bool,
  currentValue: PropTypes.string.isRequired,
  previousValue: PropTypes.string.isRequired,
  formatter: PropTypes.func.isRequired,
};

PartnerLicensePackageUsageSummary.defaultProps = {
  isLoading: false,
};

export default PartnerLicensePackageUsageSummary;
